<template>
  <div>
    <!--**********************************
  Main wrapper start
***********************************-->
    <div id="main-wrapper">
      <!--**********************************
      Content body start
  ***********************************-->
      <div class="content-body pt-0">
        <div class="container-fluid">
          <div class="form-head mb-3 d-flex flex-wrap align-items-center pt-3">
            <h2 class="font-w600 title mb-2 mr-auto">
              {{ lan.Opportunities }}
            </h2>

            <div class="d-flex justify-content-end mt-3">
              <router-link to="/add-selfopportunity"
                ><button class="filter-btn">
                  {{ lan.Create_new_opportunities }}
                </button></router-link
              >
            </div>
          </div>
          <div class="row mar-bo">
            <div class="col-xl-12">
              <div class="card">
                <div
                  class="card-header pb-2 d-block d-sm-flex flex-wrap border-0 justify-content-end"
                >
                  <div class="button justify-content-end d-flex">
                    <!-- <a href="#"><button class="search-btn">Search</button></a> -->
                    <input
                      type="search"
                      name="search"
                      class="init new-init ml-3 w-new"
                      placeholder="Search"
                      :value="search"
                      @input="onSearchChange"
                    />
                    <div class="drop-down">
                      <button
                        class="filter-btn mb-0 dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {{ lan.Filter_view }}
                      </button>
                      <div
                        class="dropdown-menu mt-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a class="dropdown-item" href="#">
                          <input
                            type="checkbox"
                            class="mr-3 sameInput"
                            id="open"
                            :checked="filterOptions.open"
                            @change="SET_FILTER_OPTIONS({ open: !filterOptions.open }); onFilterChange()"
                          />
                          <label for="open"> {{ lan.Open }}</label
                          ><br />
                        </a>
                        <a class="dropdown-item" href="#">
                          <input
                            type="checkbox"
                             class="mr-3 sameInput"
                            id="won"
                            :checked="filterOptions.won"
                            @change="SET_FILTER_OPTIONS({ won: !filterOptions.won }); onFilterChange()"
                          />
                          <label for="won">{{ lan.Won }}</label
                          ><br />
                        </a>
                        <a class="dropdown-item" href="#">
                          <input
                            type="checkbox"
                             class="mr-3 sameInput"
                            id="lost"
                            :checked="filterOptions.lost"
                            @change="SET_FILTER_OPTIONS({ lost: !filterOptions.lost }); onFilterChange()"
                          />
                          <label for="closed"> {{ lan.Closed }}</label
                          ><br />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="card-body tab-content">
                  <span class="p-3"
                    >Showing:
                    <strong
                      >( {{ fromItem }} to {{ toItem }} )</strong
                    ></span
                  >
                  <div class="tab-pane active show fade" id="monthly">
                    <div class="table-responsive">
                      <table
                        class="text-center bg-info-hover tr-rounded order-tbl"
                      >
                        <thead>
                          <tr>
                            <th></th>
                            <th>{{ lan.Account }}</th>
                            <th>{{ lan.Note }}</th>
                            <th>{{ lan.Date }}</th>
                            <th>{{ lan.Contact }}</th>
                            <th>{{ lan.Phone }}</th>
                            <th>{{ lan.Quotes }}</th>
                            <th>{{ lan.Status }}</th>
                          </tr>
                        </thead>
                        <tbody
                          v-if="
                            All_Opportunity_Details &&
                            All_Opportunity_Details.length
                          "
                        >
                          <tr
                            v-for="data in All_Opportunity_Details"
                            :key="data.opportunity_id"
                            @click="edit(data.opportunity_id)"
                            class="pointer"
                            :style="
                              data.status == 'Won'
                                ? `background-color: #ECFAE4`
                                : data.status == 'Lost'
                                ? `background-color: #FFEFEE`
                                : ''
                            "
                          >
                            <td v-if="data.seen == 0 ? true : false">
                              <i class="fa-solid fa-eye"></i>
                            </td>
                            <td v-if="data.seen == 1 ? true : false">
                              <i class="fa-sharp fa-solid fa-eye-slash"></i>
                            </td>
                            <td>{{ data.account_detail.name }}</td>
                            <td
                              v-if="data.note_detail && data.note_detail.length"
                            >
                              <span
                                v-for="(note, index) in data.note_detail"
                                :key="index"
                                >{{ note.subject }},</span
                              >
                            </td>
                            <td v-else>0</td>
                            <td>{{ data.date }}</td>
                            <td v-if="data.contact_detail != null">
                              {{ data.contact_detail.first_name }}
                              {{ data.contact_detail.last_name }}
                            </td>
                            <td v-else></td>
                            <!-- <td>89456132164</td> -->
                            <td>{{ data.contact_detail.phone }}</td>
                            <td>
                              {{ data.submitted_quotes_count }} /
                              {{ data.total_quotes_count }}
                            </td>
                            <td>
                              <span
                                class="badge light badge"
                                :class="
                                  data.status == 'Open'
                                    ? 'badge-info'
                                    : data.status == 'New'
                                    ? 'badge-success'
                                    : data.status == 'Lost'
                                    ? 'badge-danger'
                                    : 'badge-success'
                                "
                                >{{
                                  data.status == "Open"
                                    ? lan.Open
                                    : data.status == "Won"
                                    ? lan.Won
                                    : data.status == "Lost"
                                    ? lan.Lost
                                    : data.status == "New"
                                    ? lan.New
                                    : data.status
                                }}</span
                              >
                            </td>
                          </tr>
                        </tbody>
                        <div v-if="totalAPICalls != 0" class="lds-ellipsis">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </table>
                    </div>
                  </div>
                </div>

                <pagination
                  :current_page="current_page"
                  :total="total"
                  :per_page="per_page"
                  :totalPages="totalPages"
                  :loadingPageButton="loadingPageButton"
                  @page-change="pageChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--**********************************
      Content body end
  ***********************************-->
    </div>
    <!--**********************************
  Main wrapper end
***********************************-->
  </div>
</template>
<script>
import axios from "axios";
import { mapState, mapGetters, mapMutations } from "vuex";
import pagination from "../../../components/partials/pagination.vue";

export default {
  name: "Opportunity",
  components: { pagination },

  computed: {
    ...mapState({
      All_Opportunity_Details: (state) =>
        state.editOpportunity.all_Opportunity_Details,
      current_page: (state) => state.editOpportunity.current_page,
      per_page: (state) => state.editOpportunity.per_page,
      total: (state) => state.editOpportunity.total,
      totalPages: (state) => state.editOpportunity.totalPages,
      fromItem: (state) => state.editOpportunity.fromItem,
      toItem: (state) => state.editOpportunity.toItem,
      totalAPICalls: (state) => state.apiProgress.totalAPICalls,
    }),
    ...mapGetters({
      search: "getSearch",
      filterOptions: "getFilterOptions",
    }),
    lan() {
      return this.$store.getters.whichLanguage.admin[3].Opportunity[0];
    },
  },

  created() {
    // 🔥 When component loads, fetch with persisted filters
    this.$store.dispatch("Get_Opportunites", 1);
  },

  methods: {
    ...mapMutations(["SET_SEARCH", "SET_FILTER_OPTIONS"]),

    edit(id) {
      axios.post(
        axios.defaults.baseURL + "eye-open/" + id,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      localStorage.setItem("editID", id);
      this.$router.push({
        name: "Edit Opportunity",
        params: { id },
      });
    },

    onSearchChange(e) {
      this.SET_SEARCH(e.target.value);
      this.$store.dispatch("Get_Opportunites", 1);
    },

    onFilterChange() {
      this.$store.dispatch("Get_Opportunites", 1);
    },

    pageChange(page) {
      this.$store.dispatch("Get_Opportunites", page);
    },
  },
};
</script>

